import { useAppStore } from '@/stores/AppStore'
import http from '@/services/http'

export function useVoucherRepository(clinic_uuid: string) {
  const appStore = useAppStore()

  async function fetchVoucherCondition(voucher_uuid: string): Promise<string> {
    try {
      const response = await http.get(
        `${appStore.url}/api/v1/crm/line-app/p/voucher-condition/${voucher_uuid}/`,
        {
          params: {
            c: clinic_uuid,
          },
        },
      )

      return response.data
    } catch (error) {
      console.error(error)
      return ''
    }
  }

  return {
    fetchVoucherCondition,
  }
}
